import type { LayerFilterProps } from "../hooks/useUpdateLayerFilter";

import { ActiveStatusDropdown } from "./activeStatusDropdown";
import { SegmentDropdowns } from "./segmentDropdowns";

export function OfficesFilters({ layer, updateFilter }: LayerFilterProps) {
	return (
		<>
			<SegmentDropdowns layer={layer} updateFilter={updateFilter} clientSide />
			<ActiveStatusDropdown layer={layer} updateFilter={updateFilter} label="Status" />
		</>
	);
}
